var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-container"},[_c('div',{ref:"slider",attrs:{"id":"slider"}})])}
var staticRenderFns = []

export { render, staticRenderFns }